import { Reveal } from "../Reveal";
import { ZohoEmbed } from "./ZohoEmbed";
import { LegacyRequestForm } from "./LegacyRequestForm";

/**
 * Toggle to bring back the legacy custom form. When false, the native Zoho
 * CRM web-form embed is shown instead. Legacy code lives in
 * `LegacyRequestForm.jsx` so we can revert instantly by flipping this flag.
 */
const SHOW_LEGACY_FORM = false;

const ContactCopy = ({ t }) => (
  <div className="lg:col-span-5">
    <Reveal>
      <span className="eyebrow mb-8">{t.form.label}</span>
    </Reveal>
    <Reveal delay={120}>
      <h2 className="display-xl text-[34px] md:text-[44px] lg:text-[50px] mt-6">
        {t.form.title}
      </h2>
    </Reveal>
    <Reveal delay={260}>
      <div className="mt-12">
        <div className="eyebrow mb-3" style={{ color: "var(--fg-muted)" }}>
          E-mail
        </div>
        <a
          href={`mailto:${t.form.contactEmail}`}
          data-testid="contact-email"
          className="under-link font-serif text-xl md:text-2xl"
          style={{ color: "var(--green-800)" }}
        >
          {t.form.contactEmail}
        </a>
      </div>
    </Reveal>
    <Reveal delay={380}>
      <p
        className="mt-10 text-sm max-w-md"
        style={{ color: "var(--fg-muted)" }}
      >
        {t.form.note}
      </p>
    </Reveal>
  </div>
);

const ZohoShell = () => (
  <Reveal delay={180}>
    <div
      className="zoho-embed-shell p-6 md:p-10"
      style={{
        background: "var(--white)",
        borderRadius: "var(--radius-card)",
        boxShadow: "var(--shadow-md)",
        border: "1px solid var(--border)",
      }}
    >
      <ZohoEmbed />
    </div>
  </Reveal>
);

export const RequestForm = ({ t, lang }) => (
  <section
    id="contact"
    data-testid="form-section"
    className="py-24 md:py-32"
    style={{ background: "var(--mist)" }}
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <ContactCopy t={t} />
        <div className="lg:col-span-7">
          {SHOW_LEGACY_FORM ? (
            <LegacyRequestForm t={t} lang={lang} />
          ) : (
            <ZohoShell />
          )}
        </div>
      </div>
    </div>
  </section>
);
